import React from 'react';

const Loader: React.FC = () => {
  return <div id="loading"></div>;
};

export default Loader;
